import { useStore } from '@/store'
import { loadMessages } from '@/lang'

export default async function (to, from, next) {
  const store = useStore()
  await loadMessages(store.getters['lang/locale'])
  next()
}
